import { useBlankReferences } from "./useBlankReferences";

export const useBlankReferencesCount = (fontId: string) => {
  const { data: blankReferences } = useBlankReferences(fontId);

  const totalProducts = blankReferences?.custom_product_list?.length || 0;

  return { total: totalProducts };
};
